import ArticlePrice from "@/pages/(app)/returns/view/components/return-articles/article-price";
import { ReturnRequestExchangeNewProductForExchangeCreditDto } from "@babackapp/private-api-client/types";

type NewExchangeArticleProps = {
  article: ReturnRequestExchangeNewProductForExchangeCreditDto;
  currency: string;
};

export function NewExchangeArticle({
  article,
  currency,
}: NewExchangeArticleProps) {
  return (
    <div className="relative items-stretch h-28">
      <div className="absolute bg-transparent hover:bg-muted/40 rounded-lg flex gap-4 inset-2 p-2">
        <div>
          <img
            src={article.image ?? "https://placehold.co/600x400"}
            alt="exchange items"
            className="h-full aspect-[9/12] rounded-lg object-cover"
          />
        </div>
        <div className="flex-1 flex justify-between">
          <div className="flex flex-1 flex-col gap-1">
            <span className="font-semibold text-sm inline-flex items-center gap-2 flex-wrap">
              {article.title}
            </span>
            {article.sku && (
              <span className="text-xs text-muted-foreground">
                {article.sku}
              </span>
            )}
          </div>
          <div>
            <span className="text-md inline-flex items-baseline gap-1">
              <ArticlePrice
                price={article.price}
                quantity={article.quantity}
                currency={currency}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
